import React from "react";
import {
  getDepartmentColor,
  getDepartmentIcon,
  getDepartmentId,
  getDepartmentsForContext,
} from "../../core/constants/departments";
import { useDepartments } from "../../core/DepartmentsContext";

/**
 * Filter bar for Events/Users list pages.
 * Reads department list from the API catalog (filters context).
 */
const DepartmentFilterBar = ({
  selectedDepartments = [],
  onDepartmentChange,
  departmentCounts = {},
  title = "Filter by Department",
  context = "filters",
}) => {
  const { departments: catalog } = useDepartments();
  const departments = getDepartmentsForContext(context, catalog);

  return (
    <div className="filter-container" style={{ margin: "10px 0" }}>
      <h3 className="filter-title">{title}</h3>
      <div className="filters">
        {departments.map((dept) => {
          const filterValue = getDepartmentId(dept) || dept.name;
          const countKey = getDepartmentId(dept) || dept.name;

          return (
            <button
              key={filterValue}
              type="button"
              className={`filter-button ${
                selectedDepartments.includes(filterValue) ? "selected" : ""
              }`}
              onClick={() => onDepartmentChange(filterValue)}
              style={{ "--department-color": getDepartmentColor(dept, catalog) }}
            >
              <div className="department-icon">
                {getDepartmentIcon(dept, {}, catalog)}
              </div>
              <span className="department-name">{dept.name}</span>
              <span className="filter-count">
                {departmentCounts[countKey] ?? departmentCounts[dept.name] ?? 0}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default DepartmentFilterBar;
